export const safeJoin = (items: (string | null | undefined)[], separator?: string) => {
    return items.filter(Boolean).join(separator);
};

export function tryParseNumberStrict(text: string): number | undefined {
    const trimmed = text.trim();
    if (/^[0-9]+([.,][0-9]*)?$/.test(trimmed)) {
        return Number.parseFloat(trimmed);
    }
}

export function tryParseURL(text: string, defaultProtocol?: string): URL | undefined {
    const trimmed = text.trim();
    try {
        return new URL(trimmed);
    } catch {
        if (defaultProtocol) {
            return tryParseURL(defaultProtocol + trimmed);
        }
    }
}
